'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Select = require('calcite-react/Select');

var _Select2 = _interopRequireDefault(_Select);

var _Menu = require('calcite-react/Menu');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValueTypeChooser = function ValueTypeChooser(props) {
  var handleOptionChange = function handleOptionChange(e) {
    props.onChange(e);
  };

  return _react2.default.createElement(
    _Select2.default,
    {
      selectedValue: props.selectedValueType,
      onChange: handleOptionChange
    },
    _react2.default.createElement(
      _Menu.MenuItem,
      { value: 'value' },
      'Value'
    ),
    _react2.default.createElement(
      _Menu.MenuItem,
      { value: 'unique' },
      'Unique'
    )
  );
};

exports.default = ValueTypeChooser;


//////////////////
// WEBPACK FOOTER
// ./node_modules/arcgis-filter/dist/components/ValueTypeChooser.js
// module id = 1622
// module chunks = 0